import { HOST } from "../constants/HostConstants";

export const transaction = async (
  user_id,
  first_name,
  last_name,
  email_address,
  option,
  amount,
) => {
  try {
    const res = await fetch(`${HOST}/api/user/transaction`, {
      method: "POST",
      body: JSON.stringify({
        user_id,
        first_name,
        last_name,
        email_address,
        option,
        amount,
      }),
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.error || "Transaction request failed");
    }
    return { success: true, data };
  } catch (error) {
    return { success: false, error: error.message };
  }
};
